var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"basic-container",class:{'basic-container--block':_vm.block}},[(_vm.isCard)?_c('el-card',{staticClass:"h-100p ov-a",attrs:{"shadow":"never","body-style":_vm.bodyStyle}},[_vm._t("default")],2):_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }